import { render } from "./TheNumberOfUses.vue?vue&type=template&id=9221ba1c&scoped=true&lang=html"
import script from "./TheNumberOfUses.vue?vue&type=script&lang=js"
export * from "./TheNumberOfUses.vue?vue&type=script&lang=js"

import "./TheNumberOfUses.vue?vue&type=style&index=0&id=9221ba1c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9221ba1c"]])

export default __exports__